<template>
<div class="chapter">
<div class="inner_page">
<p class="part-num">BOOK I</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Part1.vue?fc38bfaa